export const AUTH_TOKEN_KEY = 'one-login-auth-token';
